import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import trafficMessageIconResource from "../../assets/trafficSituation2.svg";
import { TrafficMessage } from "../../services/RuteplanAPI";


export function Trafikkmeldinger(props: IRoutePartProps) {

    return (
        <>
            {props.roadFeatures && props.roadFeatures.trafficMessages && props.roadFeatures.trafficMessages.length > 0 &&
            <List>
                {props.roadFeatures.trafficMessages.map( (trafikkmelding: TrafficMessage, index: number) => (
                    <ListItem
                    key={trafikkmelding.situationId + index} 
                    className="roadFeature"
                    onClick={(event) => {props.onClick(trafikkmelding, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(trafikkmelding)}
                    onMouseLeave={props.onMouseLeaveItem}>            
                        <img src={trafficMessageIconResource} height="24" style={{paddingRight:"5px"}} alt="Trafikkmelding icon" title="trafikkmeldingIcon" />
                        {trafikkmelding.type}
                    </ListItem>
                ))}
            </List>
            }
        </>
    )
}